var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 4.93457H3.5C2.4 4.93457 1.5 5.83457 1.5 6.93457V17.0646C1.5 18.1646 2.4 19.0646 3.5 19.0646H20.5C21.6 19.0646 22.5 18.1646 22.5 17.0646V6.93457C22.5 5.83457 21.6 4.93457 20.5 4.93457ZM21 17.0646C21 17.3446 20.78 17.5646 20.5 17.5646H3.5C3.22 17.5646 3 17.3446 3 17.0646V11.0646H21V17.0646ZM3 8.67457V6.93457C3 6.65457 3.22 6.43457 3.5 6.43457H20.5C20.78 6.43457 21 6.65457 21 6.93457V8.67457H3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPay);
export default __webpack_public_path__ + "static/media/ic-pay.1e2049633771dd492d7cf2f3e4da8a43.svg";
export { ForwardRef as ReactComponent };